import { serviceModel } from "../../../../models";
import { InlineStartBillingMenuItem } from "./InlineStartBillingControl";
export function applyNewSelection(_ref) {
  var _handlers$onStartBill2, _handlers$onBillOnAcc2, _handlers$onPausedCha2;
  let {
    serviceId,
    newItem,
    previousItem,
    handlers,
    getInitialEffectiveDate
  } = _ref;
  switch (newItem) {
    case InlineStartBillingMenuItem.NextBillingDay:
      if (previousItem === InlineStartBillingMenuItem.ManualInitiation) {
        var _handlers$onPausedCha;
        return (_handlers$onPausedCha = handlers.onPausedChange) === null || _handlers$onPausedCha === void 0 ? void 0 : _handlers$onPausedCha.call(handlers, serviceId, false);
      } else if (previousItem === InlineStartBillingMenuItem.AcceptanceDate) {
        var _handlers$onBillOnAcc;
        return (_handlers$onBillOnAcc = handlers.onBillOnAcceptanceChange) === null || _handlers$onBillOnAcc === void 0 ? void 0 : _handlers$onBillOnAcc.call(handlers, serviceId, false);
      } else if (previousItem === InlineStartBillingMenuItem.SpecificDate) {
        var _handlers$onStartBill;
        return (_handlers$onStartBill = handlers.onStartBillingAtChange) === null || _handlers$onStartBill === void 0 ? void 0 : _handlers$onStartBill.call(handlers, serviceId, null);
      }
      break;
    case InlineStartBillingMenuItem.SpecificDate:
      (_handlers$onStartBill2 = handlers.onStartBillingAtChange) === null || _handlers$onStartBill2 === void 0 || _handlers$onStartBill2.call(handlers, serviceId, getInitialEffectiveDate());
      break;
    case InlineStartBillingMenuItem.AcceptanceDate:
    case InlineStartBillingMenuItem.Today:
      (_handlers$onBillOnAcc2 = handlers.onBillOnAcceptanceChange) === null || _handlers$onBillOnAcc2 === void 0 || _handlers$onBillOnAcc2.call(handlers, serviceId, true);
      break;
    case InlineStartBillingMenuItem.ManualInitiation:
      (_handlers$onPausedCha2 = handlers.onPausedChange) === null || _handlers$onPausedCha2 === void 0 || _handlers$onPausedCha2.call(handlers, serviceId, true);
      break;
  }
}
export function getStartBillingSelection(service) {
  if (serviceModel.isPaused(service)) {
    return InlineStartBillingMenuItem.ManualInitiation;
  }
  if (serviceModel.startBillingAt(service)) {
    return InlineStartBillingMenuItem.SpecificDate;
  }
  if (serviceModel.isBillOnPeriodBeforeNextBilling(service)) {
    if (serviceModel.isFromAmendment(service)) {
      return InlineStartBillingMenuItem.Today;
    }
    return InlineStartBillingMenuItem.AcceptanceDate;
  }
  return InlineStartBillingMenuItem.NextBillingDay;
}